import React, { useMemo, useRef } from "react"

// Copied from mission-x-web (app/comp/DotIcon.jsx). Shapes are 5x5 dot grids, [x, y].
export const ICON_SHAPES = {
    // Existing shapes
    // Bars are 1.15 rows apart (not 1) so the lines read as separate bars, ~2px extra at tile size
    gantt: [
        [0, 1],
        [1, 1],
        [2, 1], // Top bar (Left to Middle)
        [1, 2.15],
        [2, 2.15],
        [3, 2.15],
        [4, 2.15], // Middle bar (Extends all the way right)
        [2, 3.3],
        [3, 3.3],
        [4, 3.3],
        [5, 3.3], // Bottom bar (Offset, runs past the middle bar)
    ],
    budget: [
        // Top Bar & Spine
        [1, 0],
        [2, 0],
        [3, 0],
        [1, 1],
        [2, 1],

        // Middle S-curve Junction
        [2, 2],

        // Bottom Curve & Bar
        [2, 3],
        [3, 3],
        [1, 4],
        [2, 4],
        [3, 4],
    ],
    resources: [
        [0, 1],
        [0, 2],
        [0, 3], // Left resource stack
        [2, 0],
        [2, 1],
        [2, 2],
        [2, 3],
        [2, 4], // Center main stack (taller)
        [4, 1],
        [4, 2],
        [4, 3], // Right resource stack
    ],
    barChart: [
        // Left Bar (Short: 1 dot)
        [0, 4],

        // Middle Bar (Medium: 3 dots)
        [2, 2],
        [2, 3],
        [2, 4],

        // Right Bar (Tall: 5 dots)
        [4, 0],
        [4, 1],
        [4, 2],
        [4, 3],
        [4, 4],
    ],
    chart: [
        [0, 4],
        [1, 3],
        [1, 4],
        [2, 2],
        [2, 3],
        [2, 4],
        [3, 1],
        [3, 2],
        [3, 3],
        [3, 4],
        [0, 2],
        [1, 1],
        [2, 0],
        [3, 0],
    ],

    // 1. Triangle (Pyramid Grid)
    triangle: [
        [2, 0],
        [1, 1],
        [3, 1],
        [0, 2],
        [2, 2],
        [4, 2],
    ],

    // 2. Square (Border Frame with Center Core)
    square: [
        [0, 0],
        [1, 0],
        [2, 0],
        [3, 0],
        [4, 0],
        [0, 1],
        [4, 1],
        [0, 2],
        [2, 2],
        [4, 2], // Center dot
        [0, 3],
        [4, 3],
        [0, 4],
        [1, 4],
        [2, 4],
        [3, 4],
        [4, 4],
    ],
    time: [
        [2, 0], // 12 o'clock
        [0, 2],
        [2, 1],
        [4, 2], // 9 o'clock, Hour Hand, 3 o'clock
        [2, 2], // Center Pivot
        [3, 2], // Minute Hand
        [2, 4], // 6 o'clock
    ],

    // 2. Leave (Palm Tree / Sun & Wave Out-of-Office Vibe)
    leave: [
        [1, 0],
        [3, 0], // Binder rings / Top tabs
        [0, 1],
        [1, 1],
        [2, 1],
        [3, 1],
        [4, 1], // Header bar
        [0, 2],
        [2, 2],
        [4, 2], // Grid days
        [0, 3],
        [3, 3],
        [4, 3], // Grid days + checkmark
        [0, 4],
        [1, 4],
        [2, 4],
        [3, 4],
        [4, 4], // Bottom edge
    ],
    // 3. Circle (Rounded Radial Ring)
    circle: [
        [1, 0],
        [2, 0],
        [3, 0],
        [0, 1],
        [4, 1],
        [0, 2],
        [4, 2],
        [0, 3],
        [4, 3],
        [1, 4],
        [2, 4],
        [3, 4],
    ],
    analytics: [
        // Outer Circle Ring
        [2, 0],
        [0, 2],
        [4, 2],
        [2, 4],

        // Center Crosshair Origin
        [2, 2],

        // Active Radar Sweep / Ping (Top Right Quadrant)
        [3, 1],
        [4, 1],
    ],
    // 4. Pentagon (5-Point Geometric Star/Polygon)
    pentagon: [
        [2, 0], // Top tip
        [2, 1], // Upper core
        [0, 2],
        [1, 2],
        [2, 2],
        [3, 2],
        [4, 2], // Full center crossbar
        [2, 3], // Lower core
        [2, 4], // Bottom tip
    ],

    // 5. Flow Nodes (Branching Workflow / Node Network)
    flowNodes: [
        [0, 2], // Input node (Far left)
        [1, 2], // Connection line
        [2, 1],
        [2, 3], // Split junction (Top & Bottom paths)
        [3, 1],
        [3, 3], // Parallel flow paths
        [4, 1],
        [4, 3], // Output endpoints (Far right)
    ],
    expenses: [
        [1, 0],
        [2, 0],
        [3, 0], // Top edge
        [1, 1],
        [3, 1], // Sides
        [1, 2],
        [2, 2],
        [3, 2], // Middle line (Printed text line)
        [1, 3],
        [3, 3], // Sides
        [1, 4],
        [3, 4], // Jagged/cut bottom corners
    ],
    expensesCard: [
        [0, 1],
        [1, 1],
        [2, 1],
        [3, 1],
        [4, 1], // Top frame edge
        [0, 2],
        [1, 2],
        [4, 2], // Left side + EMV Chip dot
        [0, 3],
        [1, 3],
        [2, 3],
        [3, 3],
        [4, 3], // Bottom frame edge
    ],
    workspaces: [
        // Left Square (2x2)
        [0, 1],
        [1, 1],
        [0, 2],
        [1, 2],

        // Right Square (2x2)
        [3, 1],
        [4, 1],
        [3, 2],
        [4, 2],
    ],
    // Flame outline with a tall main peak and a shorter one on the left, like the 🔥 emoji
    fire: [
        [3, 0], // Main tip
        [0, 1], // Short left tip
        [2, 1],
        [4, 1], // Main peak sides
        [0, 2],
        [1, 2], // Dip between the two peaks
        [4, 2],
        [0, 3],
        [2, 3], // Inner flame
        [4, 3],
        [1, 4],
        [2, 4],
        [3, 4], // Rounded base
    ],
    // House: triangle roof over two walls with a door
    base: [
        [2, 0], // Roof peak
        [1, 1],
        [3, 1],
        [0, 2],
        [4, 2], // Roof eaves
        [1, 3],
        [3, 3], // Walls
        [1, 4],
        [2, 4], // Door
        [3, 4],
    ],
    gear: [
        [2, 0], // Top Tooth

        [1, 1],
        [2, 1],
        [3, 1], // Inner Ring Top
        [0, 2],
        [1, 2],
        [3, 2],
        [4, 2], // Left Tooth, Hollow Core, Right Tooth
        [1, 3],
        [2, 3],
        [3, 3], // Inner Ring Bottom

        [2, 4], // Bottom Tooth
    ],
}

// Procedurally generates a random symmetrical 5x5 dot shape
const generateRandomShape = () => {
    const coords = []
    // Center column always gets random dots
    for (let y = 0; y < 5; y++) {
        if (Math.random() > 0.4) coords.push([2, y])
    }
    // Left half mirrored to right half for clean symmetry
    for (let x = 0; x < 2; x++) {
        for (let y = 0; y < 5; y++) {
            if (Math.random() > 0.5) {
                coords.push([x, y]) // Left side
                coords.push([4 - x, y]) // Mirrored right side
            }
        }
    }
    // Fallback if random generation rolls empty
    return coords.length > 0
        ? coords
        : [
              [2, 0],
              [1, 2],
              [3, 2],
              [2, 4],
          ]
}

// React 16 has no useId, so each mounted icon takes the next number for its filter id.
let filterCounter = 0

// Glow pulse: each dot rests most of the cycle, brightens and swells briefly, then fades back
const PULSE_DURATION = 5
const PULSE_KEY_TIMES = "0;0.75;0.87;1"

export const DotIcon = ({
    shape,
    customCoords,
    color = "#00f2fe",
    accentColor = "#ff8a00",
    size = 64,
    dotRadius = 3.5,
    gap = 12,
    animated = true,
    seed, // Optional: pass unique ID or card index to keep random shape static across re-renders
}) => {
    // Use pre-defined shape, custom coords, or generate a random one
    const coords = useMemo(() => {
        if (customCoords) return customCoords
        if (shape && ICON_SHAPES[shape]) return ICON_SHAPES[shape]
        return generateRandomShape()
    }, [shape, customCoords, seed])

    // Two random dots per icon are drawn orange; picked once per shape so they don't jump on re-render
    const accentIndexes = useMemo(() => {
        const picked = new Set()
        const count = Math.min(2, coords.length)
        while (picked.size < count) picked.add(Math.floor(Math.random() * coords.length))
        return picked
    }, [coords])

    // Each dot gets a slot in a shuffled order, so the glow travels round the icon a dot or two at a time.
    // Negative begins start every dot mid-cycle, so nothing sits idle waiting for its first pulse.
    const pulseDelays = useMemo(() => {
        const order = coords.map((c, i) => i).sort(() => Math.random() - 0.5)
        const delays = []
        order.forEach((dotIndex, slot) => {
            delays[dotIndex] = -((slot / coords.length) * PULSE_DURATION).toFixed(2)
        })
        return delays
    }, [coords])

    // Shapes use different parts of the grid (triangle is 3 rows, gantt 6 columns), so each one is
    // centred and scaled to look as big as a full shape like fire.
    const fit = useMemo(() => {
        const xs = coords.map(([x]) => x)
        const ys = coords.map(([, y]) => y)
        const minX = Math.min(...xs)
        const minY = Math.min(...ys)
        const spanX = Math.max(...xs) - minX
        const spanY = Math.max(...ys) - minY
        // Scaled evenly (never stretched) so the shape covers about the same area as a full 5x5 one,
        // capped so its longest side stays inside the icon
        const scale = Math.min(4 / Math.sqrt(Math.max(spanX, 1) * Math.max(spanY, 1)), 5.5 / Math.max(spanX, spanY, 1))
        // Shape centre in grid units, moved onto the centre of the 80x80 box
        const centerX = 16 + (minX + spanX / 2) * gap
        const centerY = 16 + (minY + spanY / 2) * gap
        return `translate(40 40) scale(${scale}) translate(${-centerX} ${-centerY})`
    }, [coords, gap])

    // Unique ID for the SVG filter so icons on the same page don't share one
    const filterIdRef = useRef(null)
    if (filterIdRef.current === null) {
        filterCounter += 1
        filterIdRef.current = `dot-icon-glow-${filterCounter}`
    }
    const filterId = filterIdRef.current

    return (
        <svg width={size} height={size} viewBox="0 0 80 80" style={{ overflow: "visible" }}>
            <defs>
                <filter id={filterId} x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur stdDeviation="3.5" result="blur" />
                    <feMerge>
                        <feMergeNode in="blur" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>

            <g fill={color} filter={`url(#${filterId})`}>
                <g transform={fit}>
                    {coords.map(([x, y], index) => {
                        const cx = 16 + x * gap
                        const cy = 16 + y * gap
                        const opacity = 0.65 + ((x + y) % 3) * 0.15

                        return (
                            <circle
                                key={`${x}-${y}-${index}`}
                                cx={cx}
                                cy={cy}
                                r={dotRadius}
                                opacity={opacity}
                                fill={accentIndexes.has(index) ? accentColor : undefined}
                            >
                                {animated && (
                                    <>
                                        <animate
                                            attributeName="opacity"
                                            values={`${opacity};${opacity};1;${opacity}`}
                                            keyTimes={PULSE_KEY_TIMES}
                                            dur={`${PULSE_DURATION}s`}
                                            begin={`${pulseDelays[index]}s`}
                                            repeatCount="indefinite"
                                        />
                                        <animate
                                            attributeName="r"
                                            values={`${dotRadius};${dotRadius};${dotRadius * 1.35};${dotRadius}`}
                                            keyTimes={PULSE_KEY_TIMES}
                                            dur={`${PULSE_DURATION}s`}
                                            begin={`${pulseDelays[index]}s`}
                                            repeatCount="indefinite"
                                        />
                                    </>
                                )}
                            </circle>
                        )
                    })}
                </g>
            </g>
        </svg>
    )
}

export default DotIcon
